export enum UsersRouteRedirectTypeEnum {
  admins = 'Administrator',
  practitioner = 'Practitioner',
  principal = 'Principal',
  coach = 'coach',
}

export enum UsersRolesTypeEnum {
  user = 'User',
  administrator = 'Administrator',
  practitioner = 'Practitioner',
  principal = 'Principal',
  coach = 'Coach',
}

export enum idTypeEnum {
  idNumber = 'idNumber',
  passport = 'Passport',
}
